import { render, staticRenderFns } from "./BSDate.vue?vue&type=template&id=4957ab32&"
import script from "./BSDate.vue?vue&type=script&lang=js&"
export * from "./BSDate.vue?vue&type=script&lang=js&"
import style0 from "./BSDate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports